import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f0f0f0' }}>
      <p>© {new Date().getFullYear()} Mon Application. Tous droits réservés.</p>
      <nav>
        <Link to="/mentions-legales" style={{ margin: '0 10px' }}>Mentions Légales</Link>
        <Link to="/politique-de-confidentialite" style={{ margin: '0 10px' }}>Politique de Confidentialité</Link>
        <Link to="/cgv" style={{ margin: '0 10px' }}>Conditions Générales de Vente</Link>
        <Link to="/newsletter" style={{ margin: '0 10px' }}>S'inscrire à la Newsletter</Link>
        <Link to="/contact" style={{ margin: '0 10px' }}> Contactez-nous</Link>
      </nav>
    </footer>
  );
};

export default Footer;
